import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {gsap} from "gsap"
import {Possessed} from "../Possessed";
import {PossessedGameAssets} from "../PossessedGameAssets";
import {SpineGSAPWrapper} from "../animation/SpineGSAPWrapper";
import {APIEvent} from "@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem";

export class PossessedEasterEggView extends PIXI.Container implements StageLayer {

    public clickArea:PIXI.Sprite;
    private clickCount:number = 0;

    private easterEggAnimation:PIXI.spine.Spine;

    private tl:gsap.core.Timeline = gsap.timeline();

    constructor() {
        super();
        this.name = "EasterEggView";

        // Apparently click area can not be an empty container.. So we create it as a white texture with alpha 0
        this.clickArea = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.clickArea.anchor.set(0.5, 0.5);
        this.clickArea.alpha = 0;
        this.clickArea.width = 30;
        this.clickArea.height = 100;
        this.clickArea.name = "EasterEggClickArea";

        this.clickArea.on("mousedown", () => {this.onClick()});
        this.clickArea.on("tap", () => {this.onClick()});

        this.easterEggAnimation = new PIXI.spine.Spine(Possessed.assetLoader.getSpineAsset("spine/easterEgg.json"));
        this.easterEggAnimation.position.set(360, 360);
        this.easterEggAnimation.visible = false;

        // In case of bet while easter egg is playing we just skip past the animation
        Possessed.apiPlugin.events.on(APIEvent.BET, () => {
            this.tl.progress(1);
            this.clickArea.interactive = false;
            this.clickCount = 0;
        })

        this.addChild(this.clickArea);
        this.addChild(this.easterEggAnimation);
        this.updateClickAreaPos();
    }

    private onClick():void {
        this.clickCount++;
        if(this.clickCount == 3) {
            this.clickCount = 0;
            this.startEasterEggSequence();
        }
    }

    private startEasterEggSequence() {
        this.tl.progress(1);
        this.tl = gsap.timeline()
            .add(() => {
                this.clickArea.interactive = false;
                Possessed.soundPlayer.fadeOutMusic(50);
                Possessed.soundPlayer.playSound("easteregg");
                Possessed.backgroundElements.setBlackAndWhiteFilterEnabled(true);
                SpineGSAPWrapper.resetSpineState(this.easterEggAnimation);
            })
            .add(Possessed.foregroundElements.playEasterEggLogoBlink())
            .add(SpineGSAPWrapper.createTimelineForAnimation(this.easterEggAnimation, 0, "eEgg"), "<")
            .add(() => {
                this.easterEggAnimation.visible = false;
                this.clickArea.interactive = true;
                Possessed.backgroundElements.setBlackAndWhiteFilterEnabled(false);
                Possessed.soundPlayer.stopSound("easteregg");
                Possessed.soundPlayer.fadeInMusic(50);
            })
    }

    // this function gets called after the logo resizing is handled since it depends on the logo pos
    updateClickAreaPos() {
        let xOffset = NolimitApplication.isLandscape ? 33 : 45;

        this.clickArea.interactive = Possessed.foregroundElements.logo.visible;
        this.clickArea.position.copyFrom(Possessed.foregroundElements.logo.position);
        this.clickArea.position.x += xOffset;
    }
}